document.addEventListener('DOMContentLoaded', () => {
  const css = `
    .blog-page h2,
    .blog-page h3,
    .blog-page h4 {
      margin-top: 20px !important;
    }
  `;
  const inject = root => {
    const s = document.createElement('style');
    s.textContent = css;
    root.appendChild(s);
  };
  // inject into existing shadow roots
  document.querySelectorAll('*').forEach(el => {
    if (el.shadowRoot) inject(el.shadowRoot);
  });
  // observe for new shadow roots
  new MutationObserver(records => {
    records.forEach(({addedNodes}) => {
      addedNodes.forEach(node => {
        if (node.shadowRoot) inject(node.shadowRoot);
      });
    });
  }).observe(document.body, {subtree: true, childList: true});
});
